import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { AxiosResponse } from 'axios';

type Props = {
  sessionId?: string;
  documentId?: string;
  format?: string;
  templateId?: string;
  without_speakers?: boolean;
  without_timestamps?: boolean;
  token?: string; // For shared document downloads
  isShared?: boolean; // Explicitly indicates this is a shared document context
  send_to_email?: boolean; // Send export to user's email (for template exports)
};

export async function getDocumentRaw({
  sessionId,
  documentId,
  format,
  templateId,
  without_speakers,
  without_timestamps,
  token,
  isShared,
  send_to_email
}: Props): Promise<AxiosResponse<Blob>> {
  // Use sharedDocument endpoint when isShared is true OR token is provided (magic link access)
  // Otherwise use regular document endpoint (authenticated access)
  const endpoints = GET_URL(sessionId, documentId);
  const baseUrl =
    isShared || token ? endpoints.sharedDocument : endpoints.document;

  return await Axios.get(baseUrl, {
    responseType: 'blob',
    params: {
      without_speakers,
      without_timestamps,
      ...(format && { format }), // Add format for shared endpoint (query param)
      ...(templateId && { template_id: templateId }), // Add template_id for shared endpoint
      ...(token && { token }), // Add token for shared document downloads
      ...(send_to_email !== undefined && { send_to_email }) // Send to email for template exports
    }
  });
}
